/** Format total members for stat blocks and headlines (e.g. "67,689+"). */
export function formatMemberCount(count, { plus = true } = {}) {
  const total = Number(count);
  if (!Number.isFinite(total) || total <= 0) return "";
  const formatted = total.toLocaleString("en-IN");
  return plus ? `${formatted}+` : formatted;
}

/** Replace legacy hard-coded member totals inside CMS copy. */
export function withMemberCountInText(text, count) {
  if (!text || count == null || count <= 0) return text;

  const formatted = Number(count).toLocaleString("en-IN");
  const plus = `${formatted}+`;

  return text
    .replace(/more than\s+[\d,]+\+?\s+life members/gi, `more than ${formatted} life members`)
    .replace(/with\s+[\d,]+\+?\s+life members/gi, `with ${plus} life members`)
    .replace(/Search\s+[\d,]+\+?\s+life members/gi, `Search ${plus} life members`)
    .replace(/Membership today stands at\s+[\d,]+/gi, `Membership today stands at ${formatted}`)
    .replace(/With more than\s+[\d,]+\+?\s+members/gi, `With more than ${plus} members`)
    .replace(/Join\s+[\d,]+\+?\s+members/gi, `Join ${plus} members`)
    .replace(/[\d,]+\+\s+members/gi, `${plus} members`);
}

/** Inject the live total into hero stat rows labelled "Life members". */
export function withMemberCountInStats(stats, count) {
  if (!stats?.length || count == null || count <= 0) return stats;
  const value = formatMemberCount(count);
  return stats.map((stat) =>
    /life members/i.test(stat.label) ? { ...stat, value } : stat
  );
}
